import { Injectable } from '@angular/core';

import { LinkTarget } from '../../../shared/constants/link-target.enum';
import { InstrumentationService } from '../../../shared/instrumentation/instrumentation.service';
import { ErrorDialogService } from '../../../shared/services/error-dialog.service';
import { WindowUrlLauncherService } from '../../../shared/services/window-url-launcher.service';
import { CapabilitiesService } from '../../../shared/shared-context/capabilities.service';
import { AppServiceMethod } from '../../models/app-service-command.model';
import { InstalledApp } from '../../models/installed-apps-response.model';
import { PwaConfigService, PwaMockConfig } from '../pwa-config.service';
import { PwaNativeBridgeService } from '../pwa-native-bridge.service';
import { PwaUrlLauncherService } from '../pwa-url-launcher.service';

/**
 * Mock url launcher.
 */
@Injectable()
export class MockUrlLauncherService extends PwaUrlLauncherService {
    private readonly config: PwaMockConfig;

    constructor(capabilitiesService: CapabilitiesService, errorDialogService: ErrorDialogService, instrumentationService: InstrumentationService, pwaConfigService: PwaConfigService, private readonly windowUrlLauncherService: WindowUrlLauncherService) {
        super(capabilitiesService, errorDialogService, instrumentationService);
        this.config = pwaConfigService.config.mock || {};
    }

    public supportsProtocol(_protocol: string): Promise<boolean> {
        return Promise.resolve(!this.config.protocolUnsupported);
    }

    public launchUrl(url: string, linkTarget?: LinkTarget, width?: number, height?: number): Promise<void> {
        if (this.config.urlLaunchError) {
            return Promise.reject('Mock launch error');
        }

        if (url.startsWith(PwaNativeBridgeService.launchProtocol)) {
            const cidIndex = url.lastIndexOf('cid:');
            const commandString = url.substring(PwaNativeBridgeService.launchProtocol.length, cidIndex === -1 ? url.length : cidIndex);
            const command = JSON.parse(JSON.parse(commandString));
            const data = command[AppServiceMethod.LaunchApp];
            const launchedApp: InstalledApp = data.details;
            const filePath: string = data.filename;
            const launchEntry: LaunchedApp = {
                applicationName: launchedApp.name,
                filePath,
                launchMethod: AppLaunchMethod.Protocol
            };
            this.config.appsLaunched.push(launchEntry);
        }

        this.windowUrlLauncherService.openUrl(url, undefined, linkTarget, width, height);
        return Promise.resolve();
    }
}
